import {
  EmailVariableTypes,
  EmailVariables,
  RecordDynamic,
  RecordValue,
  SearchByEmail,
  TemplateValue,
  VariableValue,
} from "./EmailBuilderTypes";

export function GetVariable(
  variableType: EmailVariableTypes
): EmailVariables | null {
  if (variableType === "RecordDynamic") {
    return NewRecordDynamic();
  }
  if (variableType === "RecordValue") {
    return NewRecordValue();
  }
  if (variableType === "TemplateValue") {
    return NewTemplateValue();
  }
  if (variableType === "Value") {
    return NewValue();
  }
  if (variableType === "SearchByEmail") {
    return NewSearchByEmail();
  }

  console.error("Invalid variable type provided in GetVariable!");
  return null;
}

function NewRecordDynamic(): RecordDynamic {
  return {
    Variable: "",
    Type: "RecordDynamic",
    ModuleAPIName: "",
    FieldAPIName: "",
    FieldType: "",
    RecordID: "",
  };
}

function NewRecordValue(): RecordValue {
  return {
    Variable: "",
    Type: "RecordValue",
    FieldType: "",
    Value: "",
  };
}

function NewTemplateValue(): TemplateValue {
  return { Variable: "", Type: "TemplateValue", Value: "" };
}

function NewValue(): VariableValue {
  return { Variable: "", Type: "Value", Value: "" };
}

function NewSearchByEmail(): SearchByEmail {
  return {
    Type: "SearchByEmail",
    ModuleAPIName: "",
    EmailFieldAPIName: "",
    Variables: [],
  };
}
